module.exports = __webpack_public_path__ + "static/media/experience.f4042a1d.svg";